import * as breakpoint from '@pixelunion/breakpoint';

import Flickity from 'flickity';

const selectors = {
  container: '[data-highlights-slider]',
  highlight: '[data-highlights-block]',
};

export default class DynamicHighlightsBanner {
  constructor(section) {
    this.el = section.el;
    const { stacked } = section.data;

    this.$carousel = this.el.querySelector(selectors.container);
    this.flickity = null;
    this.flickityOptions = null;

    if (this.$carousel && this.$carousel.querySelector(selectors.highlight)) {
      this._initSlider();
    }
    breakpoint.onChange(breakpoints => this.onBreakpointChange(breakpoints));
  }

  _initSlider() {
    this.flickityOptions = {
      autoPlay: 0,
      accessibility: true,
      cellAlign: 'left',
      cellSelector: selectors.highlight,
      pageDots: false,
      prevNextButtons: false,
      contain: true,
    };

    this._bindFlickity();
  }

  onSectionUnload() {
    this._destroyFlickity();
  }

  _bindFlickity() {
    if (breakpoint.max('M') && this.flickity === null) {
      this.flickity = new Flickity(this.$carousel, this.flickityOptions);
    }
  }

  _destroyFlickity() {
    if (!this.flickity) {
      return;
    }

    this.flickity.destroy();
    this.flickity = null;
  }

  onBreakpointChange(breakpoints) {
    if (breakpoints.current.min('M') && this.flickity) {
      this._destroyFlickity();
    } else if (breakpoints.previous.min('M')) {
      this._bindFlickity();
    }
  }
}
